import metaDataSchema from './metaDataSchema.json'
import _ from 'lodash'

function buildSchema(schema: any): any {
    return _.merge(schema, metaDataSchema)
}

export {buildSchema}
